import React from 'react';
import { token } from '@atlaskit/tokens';

import styled from 'styled-components';

/**
 * E.g. - or * before or after the actual price
 */
const PriceMarkingText = styled.span`
  color: ${token('color.icon.subtle', '#626F86')};
  font-weight: lighter;
`;

export const TaxIncludedSymbol = () => <PriceMarkingText>*</PriceMarkingText>;

export const PriceDeductionSymbol = () => <PriceMarkingText>-</PriceMarkingText>;
